import { RouterState } from "react-router-redux";
import * as Calendar from "page/calendar/store";
import * as User from "user/store";
import * as Resource from "resource/store";
import * as UI from "ui/store";
import * as Event from "event/store";
import * as BurdeApiContent from "burde-api-content/store";
import { CalendarState } from "burde";

export const reducers = {
    calendar: Calendar.reducer,
    user: User.reducer,
    resource: Resource.reducer,
    ui: UI.reducer,
    event: Event.reducer,
    burdeApiContent: BurdeApiContent.reducer,
};

// The top-level state object
export interface ApplicationState {
    calendar: CalendarState;
    user: User.UserState;
    resource: Resource.ResourceState;
    routing: RouterState;
    ui: UI.UIState;
    event: Event.EventState;
    burdeApiContent: BurdeApiContent.BurdeApiContentState;
}

// This type can be used as a hint on action creators so that its
// 'dispatch' and 'getState' params are correctly typed to match your store.
export interface AppThunkAction<TAction> {
    (
        dispatch: (action: TAction) => void,
        getState: () => ApplicationState,
    ): void;
}
